export default function (Vue) {
    Vue.MapHelpers = {
        determineMapStyle() {
            if (localStorage.darkModeEnabled) {
                if(JSON.parse(localStorage.darkModeEnabled)) {
                    return 'https://api.maptiler.com/maps/darkmatter/style.json?key=8KVvDOgSDi1o5zYn2AIX';
                }
            }
            return 'https://api.maptiler.com/maps/positron/style.json?key=8KVvDOgSDi1o5zYn2AIX';
        },

        determineMapLayer() {
            if(localStorage.roadsAboveLayer) {
                if(JSON.parse(localStorage.roadsAboveLayer)) {
                    return 'highway_minor';
                }
            }
            return 'railway';
        },

        determineLayerPlacement(map, layer) {
            console.log(map)
            if(layer == 'spc') {
                return 'highway_minor'
            }
            if(layer == 'alerts') {
                if(localStorage.citiesAboveLayer) {
                    console.log(localStorage.citiesAboveLayer)
                    if(JSON.parse(localStorage.citiesAboveLayer)) {
                        if(map.getLayer('radar') && JSON.parse(localStorage.citiesAboveLayer)) {
                            return 'railway';
                        } else {
                            return 'railway';
                        }
                    } else {
                        return '';
                    }
                } else {
                    // default cities on top of radar
                    return 'railway';
                }
            }
            if(layer == 'radar') {
                if(localStorage.citiesAboveLayer) {
                    console.log(localStorage.citiesAboveLayer)
                    if(JSON.parse(localStorage.citiesAboveLayer)) {
                        if(map.getLayer('day1_general') && JSON.parse(localStorage.citiesAboveLayer)) {
                            return 'railway';
                        } else {
                            return 'railway';
                        }
                    } else {
                        return '';
                    }
                } else {
                    // default cities on top of radar
                    return 'railway';
                }
            }
        },
        isDarkModeEnabled() {
            console.log('dark mode enabled: ' + localStorage.darkModeEnabled)
            if (localStorage.darkModeEnabled) {
                if(JSON.parse(localStorage.darkModeEnabled)) {
                    return true;
                }
            }
            return false;
        },
        isRawDataEnabled() {
            console.log('raw data enabled: ' + localStorage.rawDataEnabled)
            if(localStorage.rawDataEnabled == undefined) {
                return true
            }
            if (localStorage.rawDataEnabled) {
                if(JSON.parse(localStorage.rawDataEnabled)) {
                    return true;
                }
            }
            return false;
        }
    }

    Object.defineProperties(Vue.prototype, {
        $MapHelpers: {
            get() {
                return Vue.MapHelpers
            }
        }
    })
}
